<template>
  <view class="pft-decorate-style-1-component" :style="style" flex="dir:top">
    <view
      :class="{ 'decorate-title': true, tabs: tabsPageKeys && tabsPageKeys.length }"
      :style="titleStyle"
      flex="dir:left main:justify cross:center"
    >
      <view flex="dir:left main:justify cross:center">
        <view v-if="hasTitleIcon" class="title-icon">
          <slot name="title-icon"></slot>
        </view>
        <view v-else class="title-icon">
          <img :src="TitlePreIcon" />
        </view>
        <view class="text-title">{{ title }}</view>
      </view>
      <view v-if="tabsPageKeys && tabsPageKeys.length" class="tabs">
        <view
          v-for="key in tabsPageKeys"
          :class="{ active: activeTab === key, tab: true }"
          :style="activeTab === key ? Object.assign({}, tabStyle, activeTabStyle) : tabStyle"
          @click="changeTab(key)"
          :key="key"
        >
          {{ key }}
        </view>
      </view>
      <view v-else>
        <slot name="right"></slot>
      </view>
    </view>
    <view class="decorate-contain" :style="decorateStyle" :flex="flex">
      <view v-if="tabsPageKeys && tabsPageKeys.length" class="tabs-slot" :style="slotInfactDecorate" flex="dir:left">
        <view v-for="(tab, index) of tabsPageKeys" :key="tab" :ref="addSlotDomRefs(tab)" class="tab-slot" :style="getTabStyle(index)">
          <slot :name="'tabs-' + tab"></slot>
        </view>
      </view>
      <template v-else><slot></slot></template>
    </view>
  </view>
</template>

<script lang="ts" setup>
import { ref, useSlots } from "vue"
import TitlePreIcon from "@p-v/asset/image/title_icon_pre.png"
interface DataTextProps {
  title: string
  style?: { [key: string]: string | number }
  titleStyle?: { [key: string]: string | number }
  decorateStyle?: { [key: string]: string | number }
  tabStyle?: { [key: string]: string | number }
  activeTabStyle?: { [key: string]: string | number }
  flex?: string
}
defineOptions({
  name: "Container1",
})
withDefaults(defineProps<DataTextProps>(), {
  title: () => "",
  style: () => ({ width: "100%", height: "100%" }),
  titleStyle: () => ({}),
  decorateStyle: () => ({}),
  flex: () => "dir:top main:left cross:stretch",
})
// 获取插槽内容
let slots = useSlots()

let activeTab = ref("")

let slotInfactDecorate = ref({})

let slotTabStyle = ref({})

const slotDomRefs = ref({})

const addSlotDomRefs = (key: string) => (ref: HTMLBaseElement) => {
  slotDomRefs.value[key] = ref
  // console.log(slotDomRefs)
}

const tabsPageKeysAray = Object.keys(slots).filter((key: string) => key.startsWith("tabs-"))

const tabsPageKeys = tabsPageKeysAray.map((key: string) => key.replace("tabs-", ""))

const changeTab = (key: string) => {
  activeTab.value = key
  const cur = tabsPageKeys.findIndex(key => key === activeTab.value)
  // 获取当前tab的高度
  if (slotDomRefs.value[activeTab.value]) {
    const curTabHeight = slotDomRefs.value[activeTab.value].offsetHeight

    // 设置当前tab的高度
    slotInfactDecorate.value = {
      height: `${curTabHeight}px`,
    }
  }

  slotTabStyle.value = {
    transform: `translateX(${-cur * 100}%)`,
  }
}

const getTabStyle = (index: number) => {
  const cur = tabsPageKeys.findIndex(key => key === activeTab.value)
  return {
    opacity: index === cur ? 1 : 0,
    transform: `translateX(${-cur * 100}%)`,
  }
}

if (tabsPageKeys.length) {
  changeTab(tabsPageKeys[0])
}

// console.log(slots, tabsPageKeys)

const hasTitleIcon = !!slots["title-icon"]
</script>
<style lang="scss">
.pft-decorate-style-1-component {
  padding: 16px;
  box-sizing: border-box;
  .decorate-title {
    margin-bottom: 7px;
    position: relative;
    &.tabs {
      margin-bottom: 20px;
    }
    .title-icon {
      display: flex;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .text-title {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      text-align: left;
      color: #cbe5fe;
    }
    .tabs {
      border-radius: 20px;
      border: 2px solid rgba(255, 255, 255, 0.2);
      height: 32px;
      line-height: normal;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      color: #fff;
      .tab {
        padding: 4px 16px;
        font-size: 14px;
        cursor: pointer;
        &.active {
          background: #2b97f7;
          border-radius: 32px;
        }
      }
    }
  }
  .decorate-contain {
    background: rgba(29, 45, 71, 0.75);
    border-radius: 12px 12px 12px 12px;
    padding: 16px;
    height: max-content;
    .tabs-slot {
      width: 100%;
      height: 100%;
      overflow: hidden;
      transition: all 1s;
      .tab-slot {
        display: block;
        width: 100%;
        flex-shrink: 0;
        height: max-content;
        opacity: 0;
        transition: all 1s;
      }
    }
  }
}
</style>
